import { Circle as CircleLine } from '@timelyapp/icons/line-icons';
import {
  AlertTriangle,
  ArrowCircleDown,
  ArrowCircleLeft,
  ArrowCircleRight,
  ArrowCircleUp,
  Bank,
  BankNote01,
  Bookmark,
  Box,
  Calendar,
  ChartBreakoutCircle,
  CheckCircle,
  CheckVerified02,
  Circle,
  Clock,
  ClockStopwatch,
  CodeCircle01,
  Coins03,
  Compass02,
  Contrast02,
  CurrencyDollarCircle,
  CurrencyEuroCircle,
  CurrencyPoundCircle,
  Database01,
  Eye,
  EyeOff,
  FaceSmile,
  Flag01,
  Folder,
  Gift01,
  Globe04,
  Heart,
  InfoCircle,
  Key02,
  LineChartUp05,
  Lock01,
  LockUnlocked01,
  Luggage02,
  Mark,
  MarkerPin01,
  MessageTextCircle02,
  Passport,
  Pencil01,
  PieChart01,
  PieChart03,
  Rocket02,
  Send01,
  Shield01,
  Stars01,
  Target04,
  ThumbsDown,
  ThumbsUp,
  Triangle,
  Truck01,
  User02,
  UserCircle,
  XCircle,
  XSquare,
  Zap,
} from '@timelyapp/icons/solid-icons';

export const defaultColors = [
  '#878D96',
  '#6929C4',
  '#257C6E',
  '#0072C3',
  '#D12771',
  '#EC6145',
  '#C97C08',
  '#343A3F',
] as const;

const defaultIconsList = [
  CircleLine,
  Contrast02,
  Circle,
  CheckCircle,
  CheckVerified02,
  XCircle,
  XSquare,
  Triangle,
  AlertTriangle,
  Heart,
  Folder,
  Bookmark,
  InfoCircle,
  Clock,
  ClockStopwatch,
  Calendar,
  PieChart01,
  PieChart03,
  LineChartUp05,
  ChartBreakoutCircle,
  Key02,
  LockUnlocked01,
  Lock01,
  Shield01,
  CodeCircle01,
  Database01,
  ArrowCircleLeft,
  ArrowCircleRight,
  ArrowCircleUp,
  ArrowCircleDown,
  Mark,
  Eye,
  EyeOff,
  MessageTextCircle02,
  User02,
  UserCircle,
  FaceSmile,
  ThumbsUp,
  ThumbsDown,
  BankNote01,
  Bank,
  CurrencyEuroCircle,
  CurrencyPoundCircle,
  CurrencyDollarCircle,
  Coins03,
  Send01,
  Target04,
  Globe04,
  MarkerPin01,
  Box,
  Compass02,
  Pencil01,
  Stars01,
  Passport,
  Zap,
  Luggage02,
  Gift01,
  Flag01,
  Truck01,
  Rocket02,
];

export const defaultIcons = Object.fromEntries(
  defaultIconsList.map((Icon, i) => {
    const name = Icon.displayName.replace(/[A-Z]/g, (match, offset) => {
      return (offset > 0 ? '-' : '') + match.toLowerCase();
    });

    // TODO: Add line/solid to icon metadata?
    return [name + (i === 0 ? '-line' : ''), Icon];
  })
);
